import { Button, Input, Section, Select } from "@telegram-apps/telegram-ui";
import React from "react";
import { useNavigate } from "react-router";
import duck from "./assets/duck.gif";
import BottomButtons from "./components/BottomButtons";
import { getCurrentTimeInGMT9, normalizeDate } from "./utils";

export const Main = () => {
  const navigate = useNavigate();

  type Period = "day" | "week" | "month" | "year" | "custom";

  const [period, setPeriod] = React.useState<Period>("day");
  const [from, setFrom] = React.useState<string>(
    normalizeDate(getCurrentTimeInGMT9())
  );
  const [to, setTo] = React.useState<string>(
    normalizeDate(getCurrentTimeInGMT9())
  );

  const getFrom = React.useCallback(
    (d: Date) => {
      if (period === "week") {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 6);
      } else if (period === "month") {
        return new Date(d.getFullYear(), d.getMonth(), 1);
      } else if (period === "year") {
        return new Date(d.getFullYear(), 0, 1);
      }
    },
    [period]
  );

  const getTo = React.useCallback(
    (d: Date) => {
      if (period === "week") {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 6);
      } else if (period === "month") {
        return new Date(d.getFullYear(), d.getMonth() + 1, 0);
      } else if (period === "year") {
        return new Date(d.getFullYear(), 11, 31);
      }
    },
    [period]
  );

  React.useEffect(() => {
    const today = getCurrentTimeInGMT9();
    setTo(normalizeDate(today));
    const _from = getFrom(new Date(today));
    if (_from) {
      setFrom(normalizeDate(_from));
    }
  }, [period, getFrom]);

  return (
    <>
      <div style={{ padding: 16 }}>
        <Section header="いつものように、今日の支出を見てみましょう。">
          <Select
            value={period}
            onChange={(e) => setPeriod(e.target.value as Period)}
          >
            <option value="day">1日間</option>
            <option value="week">7日間</option>
            <option value="month">1ヶ月間</option>
            <option value="year">1年間</option>
            <option value="custom">任意</option>
          </Select>
          {period === "day" ? (
            <Input
              type="date"
              value={to}
              name="to"
              onChange={(e) => {
                const v = e.target.value;
                if (v) {
                  setTo(v);
                  setFrom(v);
                }
              }}
            />
          ) : (
            <div>
              <Input
                type="date"
                value={from}
                name="from"
                after={<span style={{ fontSize: 10 }}>から</span>}
                onChange={(e) => {
                  const v = e.target.value;
                  if (v) {
                    setFrom(v);
                    const _to = getTo(new Date(v));
                    if (_to) {
                      setTo(normalizeDate(_to));
                    }
                  }
                }}
              />
              <Input
                type="date"
                value={to}
                name="to"
                after={<span style={{ fontSize: 10 }}>まで</span>}
                onChange={(e) => {
                  const v = e.target.value;
                  if (v) {
                    setTo(v);
                    const _from = getFrom(new Date(v));
                    if (_from) {
                      setFrom(normalizeDate(_from));
                    }
                  }
                }}
              />
            </div>
          )}
        </Section>
        <img
          alt="duck"
          src={duck}
          style={{
            width: "100%",
            objectFit: "contain",
          }}
        />
      </div>
      <BottomButtons>
        <div style={{ flex: 1, display: "flex", gap: 8 }}>
          <Button
            size="l"
            stretched
            onClick={() => {
              navigate(`/charts/custom?from=${from}&to=${to}`);
            }}
          >
            見る
          </Button>
          <Button size="l" stretched onClick={() => navigate("/new-expense")}>
            新規支出
          </Button>
        </div>
      </BottomButtons>
    </>
  );
};
